import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import whiteLogo from '../../assets/images/whitelogo.png';
import FooterBanner from './FooterBanner';
import { useAuth } from '../../common/Context/AuthContext';
import { APP_VERSION } from '../../config';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const { user } = useAuth();
  const footerSections = [
    {
      title: 'Products',
      links: [
        {
          name: 'Document masking',
          path: '/products#?category=Document%20Masking',
        },
        {
          name: 'Document Reader',
          path: '/products#?category=Document%20Reader',
        },
        // { name: "API Services", path: "/pcs-api" },
      ],
    },
    // {
    //   title: 'Industries',
    //   links: [
    //     { name: 'Healthcare', path: '/industries' },
    //     { name: 'Finance', path: '/industries' },
    //     { name: 'Manufacturing', path: '/industries' },
    //     { name: 'See More', path: '/industries' },
    //   ],
    // },
    // {
    //   title: "Resources",
    //   links: [
    //     // { name: "Documentation", path: "/insights" },
    //     // { name: "API Reference", path: "/pcs-api" },
    //     // { name: "Case Studies", path: "/insights" },
    //     // { name: "Blog", path: "/insights" },
    //   ],
    // },
    {
      title: 'Company',
      links: [
        { name: 'About Us', path: '/about' },
        { name: 'Talk to Sales', path: '/sales-query' },
        { name: 'Contact', path: '/sales-query' },
      ],
    },
  ];

  const socialLinks = [
    {
      icon: 'fab fa-linkedin',
      url: 'https://www.linkedin.com/company/pixdynamics/mycompany/?viewAsMember=true',
      label: 'LinkedIn',
    },
    {
      icon: 'fab fa-twitter',
      url: 'https://x.com/pix_dynamics',
      label: 'Twitter',
    },
    {
      icon: 'fab fa-youtube',
      url: 'https://www.youtube.com/@pixlAI.official',
      label: 'YouTube',
    },
    {
      icon: 'fab fa-instagram',
      url: 'https://www.instagram.com/pixl.ai_/',
      label: 'Instagram',
    },
  ];

  return (
    <>
      <div className="position-relative mt-3">
        {!user && <FooterBanner />}
        <footer
          className={`bg-black pb-0 footerMain border-top${
            user ? ' pt-0 mt-0' : ''
          }`}
        >
          {/* Main Footer Content */}
          <div className="container py-5">
            <div className="row justify-content-between g-4">
              {/* Company Info */}
              <div className="col-lg-6 mb-4 mb-lg-0">
                <Link className="d-flex align-items-center mb-4" to="/">
                  <img
                    src={whiteLogo}
                    alt="Trial Platform"
                    height="40"
                    className="d-inline-block align-text-top me-2"
                  />
                  Trial Platform
                </Link>
                <p className="mb-4 text_gray12">
                  Empowering businesses with intelligent solutions for
                  tomorrow's challenges.
                </p>
                <div className="social-links mb-4">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      className="text_dark_gray2 me-3"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.label}
                    >
                      <i className={`${social.icon} fa-lg`}></i>
                    </a>
                  ))}
                </div>
              </div>

              {/* Quick Links - Hidden when logged in */}
              {!user &&
                footerSections.map((section, index) => (
                  <div key={index} className="col-6 col-lg-2">
                    <h5 className="text-white mb-3">{section.title}</h5>
                    <ul className="list-unstyled">
                      {section.links.map((link, linkIndex) => (
                        <li key={linkIndex} className="mb-2">
                          <Link
                            to={link.path}
                            className="text-decoration-none text_dark_gray hover-primary"
                          >
                            {link.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
            </div>
          </div>
          <div className="text-center d-flex justify-content-center align-items-center">
            <h2 className="  footerLastText mb-0">
              Trial Platform
            </h2>

            <span className="hrLineFooter d-block mb-4 verison">
              {APP_VERSION && (
                <span className="text_dark_gray2 font_12 ms-2">
                  {APP_VERSION}
                </span>
              )}
            </span>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;
